<template>
	<section>
		<compFormEdit :formdata="getBase" v-model="formData"></compFormEdit>
		<compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps.show=false">
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				v-on="modalProps.on"
			/>
		</compModal>
		<vButtonGroup slot="footer" class="text-right">
			<vButton theme="primary" @click="saveBill">下一步</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import compPlanbill from './planbill';
import { HttpSaveBill } from '@/service/salesreturns';
export default {
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compModal: () => import("@components/templates/modal"),
		compPlanbill,
	},
	data() {
		return {
			formData: {},
			loading: false,
			productList: [],//入库计划单明细,
			modalProps: {
				show: false,
				// title: '导入数据',
				// component: "",
				// props: {},
				// on: {},
			}

		};
	},

	computed: {
		...mapGetters('dictionary', ['getBillcusWareList', 'getCusproductList', 'getBillcusorgList', 'getUserManageWarehouseList']),
		getBase() {
			return [{
				label: "销售退货计划单号",
				tag: "vInput",
				key: "saleReturnOrderPlanNo",
				props: {
					suffix: "search",
					readonly: true
				},
				on: {
					'on-icon-click': this.handleModal
				},
			}, {
				label: "来源单号",
				key: "sourceNo",
				required: false,
				query: true,
			},
			{
				label: "仓库",
				key: "orgWarehouseCode",
				// tag: "vSelect",
				// options: this.getBillcusWareList,
				query: true,
			},
			{
				label: "项目",
				key: "lineId",
				options: this.getCusproductList,
				query: true,
			},
			{
				label: "备注",
				key: "remark",
				tag: "vTextarea",
				required: false,
			},
			];
		},

	},
	methods: {
		handleModal() {
			this.modalProps = {
				show: true,
				width: 'large',
				title: '查找销售退货计划',
				component: "compPlanbill",
				showFooter: false,
				props: {
					startUp: true,
				},
				on: {
					'on-data': (row) => {
						this.formData = { saleReturnPlanOrderId: row.id, saleReturnOrderPlanNo: row.saleReturnPlanNo, orgWarehouseCode: row.orgWarehouseCode, lineId: row.lineId,sourceNo:row.sourceNo };
						this.modalProps = {};
					}
				}
			}
		},
		close() {
			this.$emit('on-close');
		},
		/**
		 * 保存单据
		 */
		async saveBill() {
			this.loading = true;
			HttpSaveBill({
				saleReturnOrderBaseInfo: this.formData
			}).then(res => {
				this.$router.push({
					name: 'salesreturnsBillUpdate',
					query: {
						id: res.data.saleReturnOrderBaseInfo.id
					},
					params:{
						type:'edit'
					}
				})
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		}
	}
};
</script>
